/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FlexGrid } from '@carbon/react';
import { emptyObject } from '../propHelpers/defaultProps.js';

var LayoutWrapper = function LayoutWrapper(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$gridProps = _ref.gridProps,
    gridProps = _ref$gridProps === void 0 ? emptyObject : _ref$gridProps;
  var LayoutClass = classnames('cpc--layout', className);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(FlexGrid, _extends({
      className: LayoutClass,
      fullWidth: true
    }, gridProps), children)
  );
};
LayoutWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  gridProps: PropTypes.shape({})
};
var LayoutWrapper$1 = LayoutWrapper;

export { LayoutWrapper$1 as default };
